import { apiSlice } from '../api/apiSlice'
import { RequestProps } from '../../types'
import CommentsResponse from '../../types/response/CommentsResponse'
import CustomComment from '../../types/models/CustomComment'

const commonUrl = '/comments'

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    getComments: build.query<CommentsResponse, RequestProps>({
      query: (props: RequestProps) => ({
        url: commonUrl,
        params: props,
      }),
      providesTags: () => [{ type: 'Comment', id: 'LIST' }],
    }),
    createComment: build.mutation({
      query: (comment: Partial<CustomComment>) => ({
        url: commonUrl,
        method: 'POST',
        body: comment,
      }),
      invalidatesTags: () => [
        { type: 'Comment', id: 'LIST' },
        { type: 'Candidate', id: 'LIST' },
      ],
    }),
    updateComment: build.mutation<CustomComment, EditArgs>({
      query: ({ id, body }) => ({
        url: `${commonUrl}/${id}`,
        body: body,
        method: 'PUT',
      }),
      invalidatesTags: () => [
        { type: 'Comment', id: 'LIST' },
        { type: 'Candidate', id: 'LIST' },
      ],
    }),
    deleteComment: build.mutation({
      query: (id: string) => ({
        url: `${commonUrl}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: () => [
        { type: 'Comment', id: 'LIST' },
        { type: 'Candidate', id: 'LIST' },
      ],
    }),
  }),
})

type EditArgs = {
  id: string
  body: EditComment
}

export type EditComment = {
  content: string
}

export const { useGetCommentsQuery, useCreateCommentMutation, useUpdateCommentMutation, useDeleteCommentMutation } =
  extendedApiSlice